<!-- form-unified.component.html -->
<div class="form-container">
  <!-- Étape 1 -->
  @if (currentStep === 'one') {
    <div>
      <form [formGroup]="form">
        <!-- Informations personnelles -->
        <section class="form-section" formGroupName="personalInfo">
          <h3>{{ 'FORM_UNIFIED.PERSONAL_INFO' | translate }}</h3>
          <div class="form-grid">
            <div class="form-field">
              <label for="nom">{{ 'FORM_UNIFIED.LAST_NAME' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></label>
              <input id="nom" type="text" formControlName="nom" />
            </div>
            <div class="form-field">
              <label for="prenom">{{ 'FORM_UNIFIED.FIRST_NAME' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></label>
              <input id="prenom" type="text" formControlName="prenom" />
            </div>
            <div class="form-field">
              <label for="email">{{ 'FORM_UNIFIED.EMAIL' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></label>
              <input id="email" type="email" formControlName="email" />
            </div>
            <div class="form-field">
              <label for="telephone">{{ 'FORM_UNIFIED.PHONE' | translate }}</label>
              <input id="telephone" type="tel" formControlName="telephone" />
            </div>
            <div class="form-field">
              <label for="entreprise">{{ 'FORM_UNIFIED.COMPANY' | translate }}</label>
              <input id="entreprise" type="text" formControlName="entreprise" />
            </div>
            <div class="form-field">
              <label for="fonction">{{ 'FORM_UNIFIED.POSITION' | translate }}</label>
              <input id="fonction" type="text" formControlName="fonction" [placeholder]="'FORM_UNIFIED.POSITION_PLACEHOLDER' | translate" />
            </div>
          </div>
        </section>
        <!-- Description du projet -->
        <section class="form-section">
          <h3>{{ 'FORM_UNIFIED.PROJECT_DESCRIPTION' | translate }}</h3>
          <div class="form-field">
            <label for="projectDescription">{{ 'FORM_UNIFIED.EXPLAIN_PROJECT' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></label>
            <textarea
              id="projectDescription"
              formControlName="projectDescription"
              rows="5"
              [placeholder]="'FORM_UNIFIED.PROJECT_PLACEHOLDER' | translate"
              >
            </textarea>
          </div>
        </section>
        <!-- Services et durées -->
        <section class="form-section">
          <h3>{{ 'FORM_UNIFIED.SERVICES_DURATIONS' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></h3>
          <div class="services-container">
            @for (service of serviceTypes; track service) {
              <div class="service-item">
                <div class="service-header">
                  <label [for]="service.id" class="checkbox-label">
                    <input
                      type="checkbox"
                      [id]="service.id"
                      (change)="onServiceSelect($event, service.id)"
                      />
                      <span>{{ ('FORM_UNIFIED.' + service.label) | translate }}</span>
                      @if (service.tooltip) {
                        <small class="tooltip">{{
                          ('FORM_UNIFIED.' + service.tooltip) | translate
                        }}</small>
                      }
                    </label>
                  </div>
                  <div
                    [id]="'service-options-' + service.id"
                    class="service-options hidden"
                    >
                    <div class="service-durations">
                      @for (duration of serviceDurations[service.id]; track duration) {
                        <div
                          class="duration-item"
                          >
                          <div class="duration-header">
                            <label
                              [for]="'duration-' + service.id + '-' + duration.value"
                              class="checkbox-label"
                              >
                              <input
                                type="checkbox"
                                [id]="'duration-' + service.id + '-' + duration.value"
                                (change)="onServiceDurationChange($event, service.id)"
                                [value]="duration.value"
                                />
                                <span>{{ duration.label }} - €{{ duration.price }}</span>
                              </label>
                            </div>
                            <div class="quantity-selector">
                              <label
                                [for]="'quantity-' + service.id + '-' + duration.value"
                                >{{ 'FORM_UNIFIED.QUANTITY' | translate }}:</label
                                >
                                <input
                                  type="number"
                                  [id]="'quantity-' + service.id + '-' + duration.value"
                                  min="1"
                                  value="1"
                      (change)="
                        updateServiceQuantity(
                          service.id,
                          duration.value,
                          $event
                        )
                      "
                                  />
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </section>
                <!-- Lieux de diffusion (obligatoire) -->
                <section class="form-section">
                  <h3>{{ 'FORM_UNIFIED.DIFFUSION_PLACES' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></h3>
                  <div class="diffusion-grid">
                    @for (type of diffusionTypes; track type) {
                      <div class="diffusion-item">
                        <label [for]="'diffusion-' + type" class="checkbox-label">
                          <input
                            type="checkbox"
                            [id]="'diffusion-' + type"
                            (change)="onDiffusionSelect($event, type)"
                            />
                            <span>{{ ('FORM_UNIFIED.' + type) | translate }}</span>
                          </label>
                        </div>
                      }
                    </div>
                  </section>
                  <!-- Formats audio (obligatoire) -->
                  <section class="form-section">
                    <h3>{{ 'FORM_UNIFIED.AUDIO_FORMAT' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></h3>
                    <div class="formats-grid">
                      @for (format of audioFormats; track format) {
                        <div class="format-item">
                          <label [for]="'format-' + format.value" class="checkbox-label">
                            <input
                              type="checkbox"
                              [id]="'format-' + format.value"
                              (change)="onFormatSelect($event, format.value)"
                              />
                              <span>{{ ('FORM_UNIFIED.' + format.label) | translate }}</span>
                            </label>
                          </div>
                        }
                        @if (hasOtherFormat) {
                          <div class="other-format">
                            <input
                              type="text"
                              formControlName="otherFormat"
                              [placeholder]="'FORM_UNIFIED.SPECIFY_FORMAT' | translate"
                              />
                            </div>
                          }
                        </div>
                      </section>
                      <!-- Droits d'utilisation (optionnel) -->
                      <section class="form-section">
                        <h3>{{ 'FORM_UNIFIED.USAGE_RIGHTS' | translate }} <small style="font-weight:400; opacity:0.7;">{{ 'FORM_UNIFIED.OPTIONAL_LABEL' | translate }}</small></h3>
                        <div class="rights-options">
                          <label class="radio-label">
                            <input type="radio" formControlName="rightsType" value="complete" />
                            <span>{{ 'FORM_UNIFIED.COMPLETE_RIGHTS' | translate }}</span>
                          </label>
                          <label class="radio-label">
                            <input type="radio" formControlName="rightsType" value="limited" />
                            <span>{{ 'FORM_UNIFIED.LIMITED_LICENSE' | translate }}</span>
                          </label>
                        </div>
                      </section>
                      <!-- Suivi de production (obligatoire) -->
                      <section class="form-section">
                        <h3>{{ 'FORM_UNIFIED.PRODUCTION_FOLLOW' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></h3>
                        <div class="demo-options">
                          <label class="radio-label">
                            <input type="radio" formControlName="demoOption" value="withDemo" />
                            <span>{{ 'FORM_UNIFIED.YES_DEMO' | translate }}</span>
                          </label>
                          <label class="radio-label">
                            <input type="radio" formControlName="demoOption" value="noDemo" />
                            <span>{{ 'FORM_UNIFIED.NO_DEMO' | translate }}</span>
                          </label>
                        </div>
                      </section>
                      <!-- Références sonores (obligatoire) -->
                      <section class="form-section">
                        <h3>{{ 'FORM_UNIFIED.SOUND_REFERENCES' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></h3>
                        <p class="section-description">{{ 'FORM_UNIFIED.REFERENCES_HELP' | translate }}</p>
                        <div class="reference-cards">
                          <div class="reference-card"
                            [class.active]="form.get('referenceType')?.value === 'link'"
                            (click)="selectReferenceType('link')">
                            <div class="card-icon">
                              <i class="fab fa-youtube"></i>
                            </div>
                            <h4>{{ 'FORM_UNIFIED.AUDIO_VIDEO_LINK' | translate }}</h4>
                            <p>{{ 'FORM_UNIFIED.YOUTUBE_SOUNDCLOUD' | translate }}</p>
                            @if (form.get('referenceType')?.value === 'link') {
                              <div class="card-check">
                                <i class="fas fa-check"></i>
                              </div>
                            }
                          </div>
                          <div class="reference-card"
                            [class.active]="form.get('referenceType')?.value === 'upload'"
                            (click)="selectReferenceType('upload')">
                            <div class="card-icon">
                              <i class="fas fa-cloud-upload-alt"></i>
                            </div>
                            <h4>{{ 'FORM_UNIFIED.AUDIO_FILE' | translate }}</h4>
                            <p>{{ 'FORM_UNIFIED.AUDIO_FILE_FORMATS' | translate }}</p>
                            @if (form.get('referenceType')?.value === 'upload') {
                              <div class="card-check">
                                <i class="fas fa-check"></i>
                              </div>
                            }
                          </div>
                          <div class="reference-card"
                            [class.active]="form.get('referenceType')?.value === 'record'"
                            (click)="selectReferenceType('record')">
                            <div class="card-icon">
                              <i class="fas fa-microphone"></i>
                            </div>
                            <h4>{{ 'FORM_UNIFIED.VOICE_RECORDING' | translate }}</h4>
                            <p>{{ 'FORM_UNIFIED.VOICE_DESCRIPTION' | translate }}</p>
                            @if (form.get('referenceType')?.value === 'record') {
                              <div class="card-check">
                                <i class="fas fa-check"></i>
                              </div>
                            }
                          </div>
                          <div class="reference-card"
                            [class.active]="form.get('referenceType')?.value === 'description'"
                            (click)="selectReferenceType('description')">
                            <div class="card-icon">
                              <i class="fas fa-pen-fancy"></i>
                            </div>
                            <h4>{{ 'FORM_UNIFIED.TEXT_DESCRIPTION' | translate }}</h4>
                            <p>{{ 'FORM_UNIFIED.TEXT_DESCRIPTION_DESC' | translate }}</p>
                            @if (form.get('referenceType')?.value === 'description') {
                              <div class="card-check">
                                <i class="fas fa-check"></i>
                              </div>
                            }
                          </div>
                          <div class="reference-card"
                            [class.active]="form.get('referenceType')?.value === 'none'"
                            (click)="selectReferenceType('none')">
                            <div class="card-icon">
                              <i class="fas fa-ban"></i>
                            </div>
                            <h4>{{ 'FORM_UNIFIED.NO_REFERENCE' | translate }}</h4>
                            <p>{{ 'FORM_UNIFIED.NO_REFERENCE_DESC' | translate }}</p>
                            @if (form.get('referenceType')?.value === 'none') {
                              <div class="card-check">
                                <i class="fas fa-check"></i>
                              </div>
                            }
                          </div>
                        </div>
                        @if (form.get('referenceType')?.value) {
                          <div class="reference-content-area">
                            <!-- Lien -->
                            @if (form.get('referenceType')?.value === 'link') {
                              <div class="reference-input-section">
                                <div class="input-with-icon">
                                  <i class="fas fa-link"></i>
                                  <input
                                    type="url"
                                    formControlName="referenceLink"
                                    [placeholder]="'FORM_UNIFIED.LINK_PLACEHOLDER' | translate"
                                    class="styled-input"
                                    />
                                  </div>
                                  <div class="platform-suggestions">
                                    <span class="platform-tag"><i class="fab fa-youtube"></i> YouTube</span>
                                    <span class="platform-tag"><i class="fab fa-soundcloud"></i> SoundCloud</span>
                                    <span class="platform-tag"><i class="fab fa-spotify"></i> Spotify</span>
                                    <span class="platform-tag"><i class="fab fa-vimeo"></i> Vimeo</span>
                                  </div>
                                </div>
                              }
                              <!-- Upload -->
                              @if (form.get('referenceType')?.value === 'upload') {
                                <div class="reference-input-section">
                                  <div class="file-upload-area"
                                    [class.dragover]="isDragOver"
                                    (dragover)="onDragOver($event)"
                                    (dragleave)="onDragLeave($event)"
                                    (drop)="onFileDrop($event)"
                                    (click)="fileInput.click()">
                                    <input #fileInput type="file" (change)="onFileUpload($event)" accept="audio/*" style="display: none;">
                                    <div class="upload-content">
                                      <i class="fas fa-cloud-upload-alt"></i>
                                      <h4>{{ 'FORM_UNIFIED.DRAG_FILE_HERE' | translate }}</h4>
                                      <p>{{ 'FORM_UNIFIED.CLICK_BROWSE' | translate }}</p>
                                      <small>{{ 'FORM_UNIFIED.ACCEPTED_FORMATS' | translate }}</small>
                                    </div>
                                  </div>
                                  @if (uploadedFile) {
                                    <div class="uploaded-file">
                                      <div class="file-info">
                                        <i class="fas fa-music"></i>
                                        <span class="file-name">{{ uploadedFile.name }}</span>
                                        <span class="file-size">{{ formatFileSize(uploadedFile.size) }}</span>
                                      </div>
                                      <button type="button" class="remove-file" (click)="removeUploadedFile()">
                                        <i class="fas fa-times"></i>
                                      </button>
                                    </div>
                                  }
                                </div>
                              }
                              <!-- Enregistrement -->
                              @if (form.get('referenceType')?.value === 'record') {
                                <div class="reference-input-section">
                                  <div class="recording-studio">
                                    <div class="recording-visualizer" [class.active]="isRecording">
                                      @for (bar of [1,2,3,4,5,6,7,8,9,10]; track bar) {
                                        <div class="wave-bar"
                                        [style.animation-delay]="bar * 0.1 + 's'"></div>
                                      }
                                    </div>
                                    <div class="recording-controls">
                                      <button type="button"
                                        class="record-btn"
                                        [class.recording]="isRecording"
                                        (click)="toggleRecording()">
                                        <i [class]="isRecording ? 'fas fa-stop' : 'fas fa-microphone'"></i>
                                        <span>{{ isRecording ? ('FORM_UNIFIED.STOP' | translate) : ('FORM_UNIFIED.START' | translate) }}</span>
                                      </button>
                                      @if (isRecording) {
                                        <div class="recording-info">
                                          <span class="recording-timer">{{ recordingTime }}</span>
                                          <span class="recording-status">{{ 'FORM_UNIFIED.RECORDING_IN_PROGRESS' | translate }}</span>
                                        </div>
                                      }
                                    </div>
                                    <div class="recording-tips">
                                      <h5>{{ 'FORM_UNIFIED.RECORDING_TIPS' | translate }}</h5>
                                      <ul>
                                        <li>{{ 'FORM_UNIFIED.TIP_1' | translate }}</li>
                                        <li>{{ 'FORM_UNIFIED.TIP_2' | translate }}</li>
                                        <li>{{ 'FORM_UNIFIED.TIP_3' | translate }}</li>
                                        <li>{{ 'FORM_UNIFIED.TIP_4' | translate }}</li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              }
                              <!-- Description -->
                              @if (form.get('referenceType')?.value === 'description') {
                                <div class="reference-input-section">
                                  <div class="description-area">
                                    <textarea
                                      formControlName="referenceDescription"
                                      rows="6"
                                      [placeholder]="'FORM_UNIFIED.DESCRIPTION_PLACEHOLDER' | translate"
                                      class="styled-textarea"
                                    ></textarea>
                                    <div class="character-count">
                                      <span>{{ (form.get('referenceDescription')?.value || '').length }}</span>/1000 {{ 'FORM_UNIFIED.CHARACTER_COUNT' | translate }}
                                    </div>
                                  </div>
                                  <div class="inspiration-tags">
                                    <h5>{{ 'FORM_UNIFIED.INSPIRATION_NEEDED' | translate }}</h5>
                                    <div class="tag-grid">
                                      <span class="inspiration-tag" (click)="addToDescription('energetic')">{{ 'FORM_UNIFIED.ENERGETIC' | translate }}</span>
                                      <span class="inspiration-tag" (click)="addToDescription('relaxing')">{{ 'FORM_UNIFIED.RELAXING' | translate }}</span>
                                      <span class="inspiration-tag" (click)="addToDescription('mysterious')">{{ 'FORM_UNIFIED.MYSTERIOUS' | translate }}</span>
                                      <span class="inspiration-tag" (click)="addToDescription('joyful')">{{ 'FORM_UNIFIED.JOYFUL' | translate }}</span>
                                      <span class="inspiration-tag" (click)="addToDescription('elegant')">{{ 'FORM_UNIFIED.ELEGANT' | translate }}</span>
                                      <span class="inspiration-tag" (click)="addToDescription('modern')">{{ 'FORM_UNIFIED.MODERN' | translate }}</span>
                                      <span class="inspiration-tag" (click)="addToDescription('warm')">{{ 'FORM_UNIFIED.WARM' | translate }}</span>
                                      <span class="inspiration-tag" (click)="addToDescription('epic')">{{ 'FORM_UNIFIED.EPIC' | translate }}</span>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </section>
                        <!-- Planifier un échange (obligatoire) -->
                        <section class="form-section appointment-section">
                          <h3>{{ 'FORM_UNIFIED.PLAN_MEETING' | translate }} <span class="required-field">{{ 'FORM_UNIFIED.REQUIRED_FIELD' | translate }}</span></h3>
                          <p class="section-description">{{ 'FORM_UNIFIED.CHOOSE_TIME' | translate }}</p>
                          <!-- Type de rendez-vous -->
                          <div class="meeting-types">
                            <div class="meeting-type-card"
                              [class.active]="form.get('appointment.type')?.value === 'visio'"
                              (click)="selectMeetingType('visio')">
                              <div class="meeting-icon">
                                <i class="fas fa-video"></i>
                              </div>
                              <div class="meeting-info">
                                <h4>{{ 'FORM_UNIFIED.VIDEO_CONFERENCE' | translate }}</h4>
                                <p>{{ 'FORM_UNIFIED.VIDEO_DURATION' | translate }}</p>
                                <span class="meeting-badge">{{ 'FORM_UNIFIED.RECOMMENDED' | translate }}</span>
                              </div>
                              @if (form.get('appointment.type')?.value === 'visio') {
                                <div class="meeting-check">
                                  <i class="fas fa-check"></i>
                                </div>
                              }
                            </div>
                            <div class="meeting-type-card"
                              [class.active]="form.get('appointment.type')?.value === 'phone'"
                              (click)="selectMeetingType('phone')">
                              <div class="meeting-icon">
                                <i class="fas fa-phone"></i>
                              </div>
                              <div class="meeting-info">
                                <h4>{{ 'FORM_UNIFIED.PHONE_CALL' | translate }}</h4>
                                <p>{{ 'FORM_UNIFIED.PHONE_DURATION' | translate }}</p>
                              </div>
                              @if (form.get('appointment.type')?.value === 'phone') {
                                <div class="meeting-check">
                                  <i class="fas fa-check"></i>
                                </div>
                              }
                            </div>
                            <div class="meeting-type-card"
                              [class.active]="form.get('appointment.type')?.value === 'physical'"
                              (click)="selectMeetingType('physical')">
                              <div class="meeting-icon">
                                <i class="fas fa-handshake"></i>
                              </div>
                              <div class="meeting-info">
                                <h4>{{ 'FORM_UNIFIED.PHYSICAL_MEETING' | translate }}</h4>
                                <p>{{ 'FORM_UNIFIED.PHYSICAL_DURATION' | translate }}</p>
                              </div>
                              @if (form.get('appointment.type')?.value === 'physical') {
                                <div class="meeting-check">
                                  <i class="fas fa-check"></i>
                                </div>
                              }
                            </div>
                            <div class="meeting-type-card"
                              [class.active]="form.get('appointment.type')?.value === 'none'"
                              (click)="selectMeetingType('none')">
                              <div class="meeting-icon">
                                <i class="fas fa-times-circle"></i>
                              </div>
                              <div class="meeting-info">
                                <h4>{{ 'FORM_UNIFIED.NO_MEETING' | translate }}</h4>
                                <p>{{ 'FORM_UNIFIED.NO_MEETING_DESC' | translate }}</p>
                              </div>
                              @if (form.get('appointment.type')?.value === 'none') {
                                <div class="meeting-check">
                                  <i class="fas fa-check"></i>
                                </div>
                              }
                            </div>
                          </div>
                          <!-- Calendrier et créneaux -->
                          @if (form.get('appointment.type')?.value && form.get('appointment.type')?.value !== 'none') {
                            <div class="appointment-scheduler">
                              <div class="scheduler-container">
                                <!-- Calendrier -->
                                <div class="calendar-section">
                                  <div class="calendar-header">
                                    <button type="button" class="nav-btn" (click)="previousMonth()">
                                      <i class="fas fa-chevron-left"></i>
                                    </button>
                                    <h4>{{ currentMonth | date:'MMMM yyyy':'fr' }}</h4>
                                    <button type="button" class="nav-btn" (click)="nextMonth()">
                                      <i class="fas fa-chevron-right"></i>
                                    </button>
                                  </div>
                                  <div class="calendar-grid">
                                    @for (day of weekDays; track day) {
                                      <div class="day-header">{{ ('FORM_UNIFIED.' + day) | translate }}</div>
                                    }
                                    @for (day of calendarDays; track day) {
                                      <div class="calendar-day"
                                        [class.other-month]="!day.isCurrentMonth"
                                        [class.selected]="day.date && isDateSelected(day.date)"
                                        [class.available]="day.date && isDateAvailable(day.date)"
                                        [class.today]="day.date && isToday(day.date)"
                                        (click)="selectDate(day.date)"
                                        [class.clickable]="day.date && isDateAvailable(day.date)">
                                        @if (day.date) {
                                          <span>{{ day.date.getDate() }}</span>
                                        }
                                        @if (day.date && isDateAvailable(day.date)) {
                                          <div class="availability-indicator"></div>
                                        }
                                      </div>
                                    }
                                  </div>
                                </div>
                                <!-- Créneaux horaires -->
                                @if (selectedDate) {
                                  <div class="time-slots-section">
                                    <div class="time-slots-header">
                                      <h4>{{ selectedDate | date:'EEEE d MMMM':'fr' }}</h4>
                                      <p>{{ 'FORM_UNIFIED.CHOOSE_SLOT' | translate }}</p>
                                    </div>
                                    <div class="time-slots-grid">
                                      @for (slot of getAvailableTimeSlots(selectedDate); track slot) {
                                        <div class="time-slot"
                                          [class.selected]="slot === selectedTimeSlot"
                                          (click)="selectTimeSlot(slot)">
                                          {{ slot }}
                                        </div>
                                      }
                                    </div>
                                    @if (getAvailableTimeSlots(selectedDate).length === 0) {
                                      <div class="no-slots">
                                        <i class="fas fa-calendar-times"></i>
                                        <p>{{ 'FORM_UNIFIED.NO_SLOTS' | translate }}</p>
                                        <small>{{ 'FORM_UNIFIED.CHOOSE_OTHER_DATE' | translate }}</small>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                              <!-- Résumé du rendez-vous -->
                              @if (selectedDate && selectedTimeSlot && form.get('appointment.type')?.value !== 'none') {
                                <div class="appointment-summary">
                                  <div class="summary-card">
                                    <div class="summary-header">
                                      <i class="fas fa-calendar-check"></i>
                                      <h4>{{ 'FORM_UNIFIED.APPOINTMENT_SUMMARY' | translate }}</h4>
                                    </div>
                                    <div class="summary-details">
                                      <div class="detail-row">
                                        <i class="fas fa-calendar"></i>
                                        <span>{{ selectedDate | date:'EEEE d MMMM yyyy':'fr' }}</span>
                                      </div>
                                      <div class="detail-row">
                                        <i class="fas fa-clock"></i>
                                        <span>{{ selectedTimeSlot }} ({{ 'FORM_UNIFIED.TIMEZONE' | translate }})</span>
                                      </div>
                                      <div class="detail-row">
                                        <i [class]="getMeetingTypeIcon()"></i>
                                        <span>{{ getMeetingTypeLabel() }}</span>
                                      </div>
                                      <div class="detail-row">
                                        <i class="fas fa-hourglass-half"></i>
                                        <span>{{ getMeetingDuration() }}</span>
                                      </div>
                                    </div>
                                    <div class="summary-note">
                                      <i class="fas fa-info-circle"></i>
                                      <p>{{ 'FORM_UNIFIED.CONNECTION_LINK' | translate }}</p>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                          <!-- Actions du formulaire -->
                          <div class="form-actions">
                            <button type="button" class="btn-cancel" (click)="cancelForm()">
                              {{ 'FORM_UNIFIED.CANCEL' | translate }}
                            </button>
                            <button type="button" class="btn-next" (click)="goToNextStep()" [disabled]="!isFormValid()">
                              {{ 'FORM_UNIFIED.NEXT' | translate }}
                            </button>
                          </div>
                        </section>
                      </form>
                    </div>
                  }

                  <!-- Étape 2 -->
                  @if (currentStep === 'two') {
                    <div>
                      <div class="step-two-container">
                        <p class="intro-text">
                          {{ 'FORM_UNIFIED.STEP_TWO_INTRO' | translate }}
                        </p>
                        <div class="process-cards">
                          <div class="process-card">
                            <div class="card-image">
                              <!-- Placeholder pour l'image -->
                            </div>
                            <h3>{{ 'FORM_UNIFIED.CONTACT_US' | translate }}</h3>
                            <p>{{ 'FORM_UNIFIED.EXPRESS_NEEDS' | translate }}</p>
                            <p>{{ 'FORM_UNIFIED.FILL_FORM' | translate }}</p>
                            <p>
                              {{ 'FORM_UNIFIED.START_WORK' | translate }}
                            </p>
                          </div>
                          <div class="process-card">
                            <div class="card-image">
                              <!-- Placeholder pour l'image -->
                            </div>
                            <h3>{{ 'FORM_UNIFIED.PRODUCE_TEST' | translate }}</h3>
                            <p>
                              {{ 'FORM_UNIFIED.COMPOSE_PRODUCE' | translate }}
                            </p>
                            <p>
                              {{ 'FORM_UNIFIED.SHOW_EXTRACT' | translate }}
                            </p>
                            <p>
                              {{ 'FORM_UNIFIED.FEEDBACK' | translate }}
                            </p>
                          </div>
                          <div class="process-card">
                            <div class="card-image">
                              <!-- Placeholder pour l'image -->
                            </div>
                            <h3>{{ 'FORM_UNIFIED.FINALIZE_DEMO' | translate }}</h3>
                            <p>{{ 'FORM_UNIFIED.FOUR_SEVEN_DAYS' | translate }}</p>
                            <p>
                              {{ 'FORM_UNIFIED.DELIVER_DEMO' | translate }}
                            </p>
                            <p>{{ 'FORM_UNIFIED.INVOICE' | translate }}</p>
                          </div>
                          <div class="process-card">
                            <div class="card-image">
                              <!-- Placeholder pour l'image -->
                            </div>
                            <h3>{{ 'FORM_UNIFIED.PAYMENT_DELIVERY' | translate }}</h3>
                            <p>{{ 'FORM_UNIFIED.SECURE_PAYMENT' | translate }}</p>
                            <p>{{ 'FORM_UNIFIED.IMMEDIATE_DELIVERY' | translate }}</p>
                            <div class="payment-methods">
                              <img
                                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/visa.svg"
                                alt="Visa"
                                title="Visa"
                                />
                                <img
                                  src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/mastercard.svg"
                                  alt="Mastercard"
                                  title="Mastercard"
                                  />
                                  <img
                                    src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/unionpay.svg"
                                    alt="UnionPay"
                                    title="UnionPay"
                                    />
                                    <img
                                      src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/paypal.svg"
                                      alt="PayPal"
                                      title="PayPal"
                                      />
                                      <img
                                        src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/stripe.svg"
                                        alt="Stripe"
                                        title="Stripe"
                                        />
                                        <img
                                          src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/applepay.svg"
                                          alt="Apple Pay"
                                          title="Apple Pay"
                                          />
                                          <img
                                            src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/googlepay.svg"
                                            alt="Google Pay"
                                            title="Google Pay"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <!-- À la fin du composant -->
                                      <div class="form-actions">
                                        <button type="button" class="btn-previous" (click)="goToPreviousStep()">
                                          {{ 'FORM_UNIFIED.PREVIOUS' | translate }}
                                        </button>
                                        <button type="button" class="btn-next" (click)="goToNextStep()">
                                          {{ 'FORM_UNIFIED.NEXT' | translate }}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                }

                                <!-- Étape 3 -->
                                @if (currentStep === 'three') {
                                  <div>
                                    <div class="step-three-container">
                                      <p class="intro-text">
                                        {{ 'FORM_UNIFIED.STEP_THREE_INTRO' | translate }}
                                      </p>
                                      <div class="documents-container">
                                        <!-- Devis Section -->
                                        <div class="devis-section">
                                          <h3>{{ 'FORM_UNIFIED.QUOTE' | translate }}</h3>
                                          <div class="devis-actions">
                                            <button type="button" class="btn-enlarge" (click)="openQuoteModal()" [disabled]="!quoteObjectUrl" aria-label="Agrandir le devis">
                                              <i class="fas fa-expand"></i>
                                              {{ 'FORM_UNIFIED.CLICK_TO_ENLARGE' | translate }}
                                            </button>
                                            <button type="button" class="btn-download" (click)="downloadQuote()" [disabled]="!quoteObjectUrl || !hasValidSignature()">
                                              <i class="fas fa-download"></i>
                                              {{ 'FORM_UNIFIED.DOWNLOAD_QUOTE' | translate }}
                                            </button>
                                          </div>
                                          <!-- Preview zone strictly constrained; clicking opens modal -->
                                          <div class="devis-preview" (click)="openQuoteModal()" [class.clickable]="!!quoteObjectUrl" role="button" tabindex="0" aria-label="Open quote preview in modal" (keydown.enter)="openQuoteModal()" (keydown.space)="$event.preventDefault(); openQuoteModal()">
                                            @if (quoteObjectUrl) {
                                              <iframe class="devis-iframe" [src]="quoteViewerUrl | safeUrl" title="Devis" loading="lazy"></iframe>
                                              <div class="preview-overlay" aria-hidden="true"><span>{{ 'FORM_UNIFIED.CLICK_TO_ENLARGE' | translate }}</span></div>
                                            } @else {
                                              <div class="devis-building">
                                                <i class="fas fa-file-pdf"></i>
                                                <span>{{ 'FORM_UNIFIED.BUILDING_QUOTE' | translate }}</span>
                                              </div>
                                            }
                                          </div>
                                        </div>
                                        <!-- CGV Section -->
                                        <div class="cgv-section">
                                          <h3>{{ 'FORM_UNIFIED.TERMS_CONDITIONS' | translate }}</h3>
                                          <div class="cgv-content" #cgvContent>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_1_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_1_P1' | translate }}</p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_1_P2' | translate }}</p>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_2_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_2_P1' | translate }}</p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_2_P2' | translate }}</p>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_3_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_3_P1' | translate }}</p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_3_P2' | translate }}</p>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_4_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_4_P1' | translate }}</p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_4_P2' | translate }}</p>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_5_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_5_P1' | translate }}</p>
                                            <ul>
                                              <li>{{ 'FORM_UNIFIED.TERMS.ARTICLE_5_LI1' | translate }}</li>
                                              <li>{{ 'FORM_UNIFIED.TERMS.ARTICLE_5_LI2' | translate }}</li>
                                            </ul>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_5_P2' | translate }}</p>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_6_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_6_P1' | translate }}</p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_6_P2' | translate }}</p>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_7_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_7_P1' | translate }}</p>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_8_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_8_P1' | translate }}</p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_8_P2' | translate }}</p>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_9_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_9_P1' | translate }}</p>
                                            <p><strong>{{ 'FORM_UNIFIED.TERMS.ARTICLE_10_TITLE' | translate }}</strong></p>
                                            <p>{{ 'FORM_UNIFIED.TERMS.ARTICLE_10_P1' | translate }}</p>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- Section Signature Électronique -->
                                      <div class="signature-section">
                                        <h3>{{ 'FORM_UNIFIED.ELECTRONIC_SIGNATURE' | translate }}</h3>
                                        <p class="signature-intro">
                                          {{ 'FORM_UNIFIED.SIGNATURE_INTRO' | translate }}
                                        </p>
                                        <!-- Options de signature -->
                                        <div class="signature-options">
                                          <div class="signature-option"
                                            [class.active]="signatureMethod === 'draw'"
                                            (click)="selectSignatureMethod('draw')">
                                            <div class="option-icon">
                                              <i class="fas fa-pen"></i>
                                            </div>
                                            <h4>{{ 'FORM_UNIFIED.DRAW_SIGNATURE' | translate }}</h4>
                                            <p>{{ 'FORM_UNIFIED.SIGN_ON_SCREEN' | translate }}</p>
                                          </div>
                                          <div class="signature-option"
                                            [class.active]="signatureMethod === 'upload'"
                                            (click)="selectSignatureMethod('upload')">
                                            <div class="option-icon">
                                              <i class="fas fa-upload"></i>
                                            </div>
                                            <h4>{{ 'FORM_UNIFIED.IMPORT_IMAGE' | translate }}</h4>
                                            <p>{{ 'FORM_UNIFIED.UPLOAD_SIGNATURE' | translate }}</p>
                                          </div>
                                        </div>
                                        <!-- Zone de signature selon la méthode choisie -->
                                        @if (signatureMethod) {
                                          <div class="signature-area">
                                            <!-- Signature dessinée -->
                                            @if (signatureMethod === 'draw') {
                                              <div class="draw-signature">
                                                <div class="signature-pad-container">
                                                  <canvas #signatureCanvas
                                                    width="500"
                                                    height="200"
                                                    (mousedown)="startDrawing($event)"
                                                    (mousemove)="draw($event)"
                                                    (mouseup)="stopDrawing()"
                                                    (touchstart)="startDrawing($event)"
                                                    (touchmove)="draw($event)"
                                                  (touchend)="stopDrawing()"></canvas>
                                                  <div class="signature-instructions">
                                                    <i class="fas fa-info-circle"></i>
                                                    <span>{{ 'FORM_UNIFIED.SIGN_IN_FRAME' | translate }}</span>
                                                  </div>
                                                </div>
                                                <div class="draw-actions">
                                                  <button type="button" class="btn-confirm" (click)="confirmDrawSignature()" [disabled]="!drawDirty">OK</button>
                                                </div>
                                              </div>
                                            }
                                            <!-- Upload de signature -->
                                            @if (signatureMethod === 'upload') {
                                              <div class="upload-signature">
                                                <div class="signature-upload-area"
                                                  [class.dragover]="isSignatureDragOver"
                                                  (dragover)="onSignatureDragOver($event)"
                                                  (dragleave)="onSignatureDragLeave($event)"
                                                  (drop)="onSignatureDrop($event)"
                                                  (click)="signatureFileInput.click()"
                                                  title="Veuillez importer une image de votre signature manuscrite uniquement (pas de logo ni de texte).">
                                                  <input #signatureFileInput
                                                    type="file"
                                                    (change)="onSignatureUpload($event)"
                                                    accept="image/png,image/jpeg"
                                                    style="display: none;">
                                                    @if (!uploadedSignature) {
                                                      <div class="upload-content">
                                                        <i class="fas fa-cloud-upload-alt"></i>
                                                        <h4>{{ 'FORM_UNIFIED.DRAG_SIGNATURE' | translate }}</h4>
                                                        <p>{{ 'FORM_UNIFIED.CLICK_BROWSE' | translate }}</p>
                                                        <small>{{ 'FORM_UNIFIED.PNG_JPEG_FORMAT' | translate }}</small>
                                                        <small class="hover-note">Importez uniquement une signature réelle (manuscrite).</small>
                                                      </div>
                                                    }
                                                    @if (uploadedSignature) {
                                                      <div class="signature-preview">
                                                        <img [src]="uploadedSignature" alt="Signature" />
                                                        <button type="button" class="remove-signature" (click)="removeUploadedSignature($event)">
                                                          <i class="fas fa-times"></i>
                                                        </button>
                                                      </div>
                                                    }
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          }
                                          <!-- Informations légales -->
                                          @if (signatureMethod) {
                                            <div class="legal-info">
                                              <div class="legal-notice">
                                                <i class="fas fa-shield-alt"></i>
                                                <div class="notice-content">
                                                  <h5>{{ 'FORM_UNIFIED.LEGAL_VALUE' | translate }}</h5>
                                                  <p>
                                                    {{ 'FORM_UNIFIED.LEGAL_NOTICE' | translate }}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          }
                                          <!-- Actions de signature -->
                                          @if (signatureMethod) {
                                            <div class="signature-actions">
                                              <button type="button" class="btn-clear" (click)="clearSignature()">
                                                <i class="fas fa-eraser"></i>
                                                {{ 'FORM_UNIFIED.CLEAR' | translate }}
                                              </button>
                                              <button type="button" class="btn-previous" (click)="goToPreviousStep()">
                                                <i class="fas fa-arrow-left"></i>
                                                {{ 'FORM_UNIFIED.PREVIOUS' | translate }}
                                              </button>
                                              <button type="button"
                                                class="btn-sign"
                                                (click)="validateSignature()"
                                                [disabled]="!hasValidSignature()">
                                                <i class="fas fa-signature"></i>
                                                {{ 'FORM_UNIFIED.SIGN_FINALIZE' | translate }}
                                              </button>
                                            </div>
                                          }
                                          <!-- Option de retour ultérieur -->
                                          @if (!signatureMethod) {
                                            <div class="return-later">
                                              <button type="button" class="btn-save-draft" (click)="saveDraftAndReturn()">
                                                <i class="fas fa-save"></i>
                                                {{ 'FORM_UNIFIED.SAVE_RETURN_LATER' | translate }}
                                              </button>
                                            </div>
                                          }
                                        </div>
                                        <!-- Quote Modal -->
                                        @if (showQuoteModal) {
                                          <div class="quote-modal-overlay" (click)="onBackdropClick($event)">
                                            <div class="quote-modal" role="dialog" aria-modal="true">
                                              <button type="button" class="close-x" (click)="closeQuoteModal()" [attr.aria-label]="('FORM_UNIFIED.CLOSE' | translate)">×</button>
                                              <iframe class="quote-iframe" [src]="quoteViewerUrl | safeUrl" title="Devis complet"></iframe>
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
